import { Component } from '@angular/core';

@Component({
    selector: '[page_loading]',
  templateUrl: 'page-loading.component.html',
  host: { '[class.modal]': '\'true\'', '[class.modal-static]': '\'true\'', '[attr.role]': '\'dialog\'', '[attr.id]': '\'processing-modal\'' }
})

export class PageLoadingComponent { }